import React from 'react';
import { Toaster } from 'react-hot-toast';

const CustomToaster = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1e293b',
          color: '#f8fafc', 
          border: '1px solid #334155',
          borderRadius: '0.75rem',
          padding: '16px',
          fontSize: '14px',
          fontWeight: '500',
          boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
        },
        
        success: {
          duration: 3000,
          style: {
            background: '#065f46',
            color: '#d1fae5',
            border: '1px solid #10b981',
          },
          iconTheme: {
            primary: '#10b981',
            secondary: '#d1fae5',
          },
        },
        
        error: {
          duration: 5000,
          style: {
            background: '#7f1d1d',
            color: '#fecaca',
            border: '1px solid #ef4444',
          },
          iconTheme: {
            primary: '#ef4444',
            secondary: '#fecaca',
          },
        },
        
        loading: {
          style: {
            background: '#374151',
            color: '#f3f4f6',
            border: '1px solid #6b7280',
          },
        },
      }}
    />
  );
};

export default CustomToaster; 